<template>
    <div>
        <div v-for="item in tree" :key="item.id" style="font-size:18px;" onselectstart="return false">
            <div @click="typeClick(item)" style="cursor: pointer;height: 40px;line-height: 40px;" :title="'id='+item.id+'&'+'parentId='+item.parentId">
                <i style="color:#303030" :class="item.showing ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
                <i style="color:#303030" v-show="item.loading" class="el-icon-loading"></i>
                <div style="color:#303030; margin-left:15px;display: inline-block;">
                    {{item.label}}
                </div>
                <el-button style="float:right;margin-left: 10px;" type="primary" icon="el-icon-plus" v-allow='"新增"' @click.stop="add(item)"></el-button>
<!--                <el-button v-if="item.id !== 0" style="float:right;" type="danger" icon="el-icon-delete" @click.stop="remove(item)"></el-button>-->
                <el-button v-if="item.id !== 0" style="float:right;" type="primary" icon="el-icon-edit"  v-allow='"编辑"' @click.stop="edit(item)"></el-button>
            </div>
<!--            <transition name="fade">-->
                <div v-if="item.children && item.children.length"
                     v-show="item.showing"
                     style="padding-left: 15px;"
                     :style="{height: item.showing ? 'auto' : '0'}">
<!--                     -->

                    <tree :tree="item.children" @type-click="typeClick" @add="add" @remove="remove" @edit="edit"></tree>
                </div>
<!--            </transition>-->
        </div>
    </div>
</template>
<script>

    export default {
        name: 'tree',
        props: {
            tree: {
                type: Array,
                required: true
            }
        },
        methods: {
            typeClick(item) {
                this.$emit('type-click', item)
            },
            add(item) {
                this.$emit('add', item)
            },
            remove(item) {
                this.$emit('remove', item)
            },
            edit(item) {
                this.$emit('edit', item)
            },
        }
    }
</script>
<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: all .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        height: 0;
    }
</style>